import Vue from 'vue'
import Vuex from 'vuex'
import AuthModule from './modules/AuthModule'
import HomeModule from './modules/HomeModule'
import DetailModule from './modules/DetailModule'
import IntegrationsModule from './modules/IntegrationsModule'
import IntegrationFormModule from './modules/IntegrationFormModule'
import PartnersModule from './modules/PartnersModule'
import PartnerFormModule from './modules/PartnerFormModule'
import QueriesModule from './modules/QueriesModule'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        auth: AuthModule,
        home: HomeModule,
        detail: DetailModule,
        integration: IntegrationsModule,
        integrationForm: IntegrationFormModule,
        partners: PartnersModule,
        partnerForm: PartnerFormModule,
        query: QueriesModule,
    },
})
